<template>
  <load-page>
    <!--
    ============================================================================
    Tabs
    ============================================================================
    -->
    <template slot="tabs">
      <b-tab :title="$t('settings.tabs.main')" active class="scrollable">
        <div class="padded">
          <string-form-field
            :label="$t('settings.fields.username')"
            required
            :value="value.username"
            :disabled="disabled"
            @input="propertyChange('username', $event)">
            <b-input-group-text slot="prepend">
              <i class="fa fa-fw fa-user"></i>
            </b-input-group-text>
          </string-form-field>

          <!-- TODO Translate -->
          <options-form-field
            :label="$t('settings.fields.language')"
            required
            dropdown
            :options="[
              'it',
              'en'
            ]"
            :value="value.language"
            :disabled="disabled"
            @input="propertyChange('language', $event)">
            <b-input-group-text slot="prepend">
              <i class="fa fa-fw fa-flag"></i>
            </b-input-group-text>
          </options-form-field>

          <!-- TODO Translate -->
          <options-form-field
            :label="$t('settings.fields.dateFormat')"
            required
            dropdown
            :options="[
              { value: 'DD_MM_YYYY', text: 'dd/mm/yyyy' },
              { value: 'MM_DD_YYYY', text: 'mm/dd/yyyy' },
              { value: 'YYYY_MM_DD', text: 'yyyy/mm/dd' }
            ]"
            :value="value.dateFormat"
            :disabled="disabled"
            @input="propertyChange('dateFormat', $event)">
            <b-input-group-text slot="prepend">
              <i class="fa fa-fw fa-calendar"></i>
            </b-input-group-text>
          </options-form-field>

          <string-form-field
            :label="$t('settings.fields.decimalSeparator')"
            required
            :value="value.decimalSeparator"
            :disabled="disabled"
            @input="propertyChange('decimalSeparator', $event)">
            <!--
            <b-input-group-text slot="prepend">
              <i class="fa fa-fw fa-calendar"></i>
            </b-input-group-text>
            -->
          </string-form-field>

          <string-form-field
            :label="$t('settings.fields.thousandSeparator')"
            required
            :value="value.thousandSeparator"
            :disabled="disabled"
            @input="propertyChange('thousandSeparator', $event)">
            <!--
            <b-input-group-text slot="prepend">
              <i class="fa fa-fw fa-calendar"></i>
            </b-input-group-text>
            -->
          </string-form-field>
        </div>
      </b-tab>
    </template>
    <!--
    ============================================================================
    Buttons
    ============================================================================
    -->
    <template slot="buttons">
      <b-button variant="cancel" class="float-left" @click.prevent="cancel()">
        {{ $t("common.cancel") }}
      </b-button>
      <!--
      <b-button variant="remove" @click.prevent="remove()">
        {{ $t("common.remove") }}
      </b-button>
      -->
      <b-button variant="save" @click.prevent="save()">
        {{ $t("common.save") }}
      </b-button>
    </template>
  </load-page>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import { LoggedUserService } from "vue-template";

export default {
  mixins: [ EditorMixin ],

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    // TODO handle errors
    async save() {
      const saved = LoggedUserService.save({ instance: this.value });
      console.log("saved", saved);
      this.$emit("saved", saved);
    }
  }
};
</script>
